import _ from 'lodash'

class ItemPreview {
  id: number | string;
  base_id: string;
  title: string;
  description: string;
  type: string;
  parent_id?: number | string;
  options: Record<string, any> = {};
  response: any;
  rule_set: any;
  grouped_item: any;
  image_marker: any;
  info: any;
  simple_rule: any;

  constructor(data: Partial<ItemPreview>) {
    const {
      id = '',
      base_id = '',
      title = '',
      description = '',
      type = '',
      parent_id = '',
      options = {},
      response = null,
      rule_set = null,
      grouped_item = null,
      image_marker = null,
      info = null,
      simple_rule = null
    } = data
    this.id = id
    this.base_id = base_id
    this.title = title
    this.description = description
    this.type = type
    this.parent_id = parent_id
    this.options = options
    this.response = response
    this.rule_set = rule_set
    this.grouped_item = grouped_item
    this.image_marker = image_marker
    this.info = info
    this.simple_rule = simple_rule
  }

  static fromTemplatePreviewItem(item: Partial<ItemPreview>, template: any): ItemPreview {
    if (item?.options?.response_set_id) {
      if (template?.response_sets) {
        const responseSet = _.find(template?.response_sets, (set: any) => set.id === item?.options?.response_set_id)
        if (responseSet) {
          item.response = responseSet
        }
      }
    }
    if (item?.options?.simple_rule) {
      item.simple_rule = item.options.simple_rule
    }
    return new ItemPreview(item)
  }
}

export { ItemPreview }